export interface IPartnerModalComponent {
	data: IPartnerModalData<{}>;
	closeEvent: (e?: {}) => void;
}

export interface IPartnerModalData<T> {
	type: IPartnerModalTypes;
	title?: string;
	options?: T;
}

export enum IPartnerModalTypes {
	generateLinks = 'generateLinks',
	confirmLinkDelete = 'confirmLinkDelete',
	onboardAccounts = 'onboardAccounts',
	reonoboardAccounts = 'reonboardAccounts',
	finishOnboarding = 'finishOnboarding',
	addOrganization = 'addOrganization',
	selectOU = 'selectOU',
}
